import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/Logo/myginnelogo.svg";
import BarcodeScanner from "react-barcode-reader";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { Image } from "antd";
import LoginForm from "../login/loginForm";
import round from "../../assets/Images/roundimage.png";
import dropdown from "../../assets/Order/arrow_drop_down.svg";
import { LogoutOutlined } from "@ant-design/icons";
import axios from "axios";
import { toast } from "react-toastify";
import LanguageSwitcher from "../../components/language-switcher";
import { logoutUser } from "../../Redux/Action/loginAction";

const priceCheckerAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
});

priceCheckerAxios.interceptors.request.use((config) => {
  const loginData = JSON.parse(localStorage.getItem("priceCheckerLogin"));

  if (loginData?.access_token) {
    config.headers["access-token"] = loginData.access_token;
  }

  if (loginData?.company_id) {
    config.headers["Store-Id"] = loginData.company_id;
  }

  config.headers["Is-All-Store"] = "false";

  return config;
});
const PriceChecker = () => {
  const { t, i18n } = useTranslation();
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();

  const [barcode, setBarcode] = useState("");
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [lang, setLang] = useState("ar");
  const [profileName, setprofileName] = useState("Hi User");
  const [profileImage, setprofileImage] = useState("");
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );

  useEffect(() => {
    try {
      const storedData = localStorage.getItem("priceCheckerLogin");

      if (storedData) {
        const parsed = JSON.parse(storedData);
        setAccessToken(storedData?.access_token);
        setCompanyId(parsed?.company_id || null);
        setprofileImage(parsed?.image_url);
      }
    } catch (err) {
      console.error("Invalid localStorage data");
      setCompanyId(null);
    }
  }, [companyId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const searchBarcodeResult = async (val) => {
    try {
      setLoading(true);
      let payload = {
        barcode: val,
        company_id: company_id ? company_id : companyId,
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
      };
      let response;
      if (company_id) {
        response = await axiosInstance.post(URLS.CHECK_PRICE, payload);
      } else {
        response = await priceCheckerAxios.post(URLS.CHECK_PRICE, payload);
      }

      // console.log("res1---->", res1);

      if (response?.data?.result?.status_code === 200) {
        setProductData(response?.data?.result?.response);
      } else {
        toast.error(t("Product not found"));
        setProductData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      setLoading(false);

      // setloading(false);
    }
  };

  // Auto reset to scan screen after 10 sec
  useEffect(() => {
    if (productData?.prod_id) {
      const timer = setTimeout(() => {
        setProductData(null);
        setBarcode("");
      }, 30000);

      return () => clearTimeout(timer);
    }
  }, [productData]);

  if (!company_id && !companyId) {
    return (
      <div className="flex flex-col items-center justify-center overflow-hidden ">
         <div className="relative flex items-center justify-between py-5 px-10 border-b border-gray-300 w-full">
         
        <div className="">
          <Image
            src={require("../../assets/Logo/logo.png")}
            alt="myGINNE logo"
            width={120}
            height={37}
            preview={false}
          />
        </div>
         <LanguageSwitcher setLoading={setLoading} />
      </div>
       <div className="w-96">
            <div
          className="flex flex-col items-start mb-2.5"
          style={{ marginTop: "rem" }}
        >
          <h1
            className="font-semibold text-gray-800  text-2xl "
            style={{ marginTop: "2rem" }}
          >
            {t("Login")}
          </h1>
        </div>
          <LoginForm
            isPriceChecker={true}
            setCompanyIDForPriceChecker={setCompanyId}
          />
          </div>
        
      </div>
    );
  }

  const handleToggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("priceCheckerLogin");
    setCompanyId(null);
     const currentLang = localStorage.getItem("selectedLanguage");
        localStorage.clear();
        dispatch(logoutUser());
        localStorage.setItem("selectedLanguage", currentLang);
        
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-slate-200">
      {/* Header */}
      <div className="relative flex items-center justify-between py-5 px-10 border-b border-gray-300">
        <div className="">
          <Image
            src={require("../../assets/Logo/logo.png")}
            alt="myGINNE logo"
            width={120}
            height={37}
            preview={false}
          />
        </div>
        <h1 className="text-xl font-semibold text-gray-800">
          {t("Price Checker")}
        </h1>

        <div className="flex gap-x-2 items-center">
         <LanguageSwitcher setLoading={setLoading} />
           {companyId ? (
          <div className="relative mx-4" ref={dropdownRef}>
            <button
              className="p-2 ps-1 w-20 h-10 bg-none rounded-3xl border bg-white border-gray-300 cursor-pointer flex items-center"
              onClick={handleToggleDropdown}
            >
              {profileImage ? (
                <img
                  className="me-3 h-8 w-8 object-cover rounded-full"
                  src={profileImage}
                  width={30}
                  height={30}
                  alt="Profile"
                />
              ) : (
                <img className="w-8 h-8" src={round} alt="Default Profile" />
              )}
              <img
                className={`absolute ${
                  i18n.language == "en" ? "right-3" : "left-3"
                }`}
                src={dropdown}
                alt="Dropdown"
              />
            </button>
            {isDropdownVisible && (
              <div className="absolute w-28 top-full mt-1 bg-white border rounded-lg shadow">
                <div
                  className="p-3 cursor-pointer text-sm"
                  onClick={handleLogout}
                >
                  <LogoutOutlined style={{ zIndex: 1 }} /> {t("logout")}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="w-12" />
        )}
        </div>
       
      </div>

      {/* {productData?.prod_id&& <>
       {loading ? <div className="relative flex justify-center items-center h-12 mt-4">
    <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
  </div> : 
               <p className="relative text-lg font-semibold text-gray-700 mt-4">
                {t("Scan the product barcode")}
              </p>
              }
      </>} */}
      {/* ================= CONDITIONAL CONTENT ================= */}
      <div className="flex flex-1 items-center justify-center px-28">
        {productData?.prod_id ? (
          <>
            <div className="flex w-full justify-between items-center">
              {/* Product Name Section */}
              <div className="space-y-4 max-w-2xl mb-2">
                <h3
                  className="text-5xl font-medium text-gray-900"
                >
                  {barcode}
                </h3>
                {productData?.name_ar && (
                  <h2 className="text-5xl font-semibold text-gray-900  leading-normal">
                    {productData?.name_ar}
                  </h2>
                )}
                {productData?.name_ar != productData?.name && (
                  <h3
                    className="text-5xl font-semibold text-gray-900 leading-normal"
                  >
                    {productData?.name}
                  </h3>
                )}
              </div>

              {/* Price Box */}
              <div className="bg-gray-100 rounded-3xl px-16 py-32 shadow-sm">
                {loading ? 
                <div className="relative flex justify-center items-center h-12 mx-32">
                  <div className="w-20 h-20 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>: 
                <h2 className="text-7xl font-bold text-gray-900">
                  {productData?.currency || "EGP"}{" "}
                  {productData?.sale_price.toFixed(2)}
                </h2>
                }
                
              </div>
            </div>
          </>
        ) : (
          /* ================= SCAN SCREEN ================= */
          <div className="bg-gray-100 rounded-3xl shadow-sm w-[720px] py-20 px-10  text-center">
            <h2 className="text-2xl font-semibold mb-10">
              {t("Know Your Product")}
            </h2>

            <div className="relative bg-white rounded-2xl py-16 px-10 overflow-hidden">
              {/* Fake barcode background */}
              <div className="absolute inset-0 opacity-20 flex justify-center items-center">
                <div className="flex gap-2">
                  {Array.from({ length: 25 }).map((_, i) => (
                    <div
                      key={i}
                      className="bg-gray-400"
                      style={{
                        width: i % 2 === 0 ? "3px" : "6px",
                        height: "120px",
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Corners */}
              <div className="absolute top-6 left-6 w-8 h-8 border-t-2 border-l-2 border-gray-800 rounded-tl-xl" />
              <div className="absolute top-6 right-6 w-8 h-8 border-t-2 border-r-2 border-gray-800 rounded-tr-xl" />
              <div className="absolute bottom-6 left-6 w-8 h-8 border-b-2 border-l-2 border-gray-800 rounded-bl-xl" />
              <div className="absolute bottom-6 right-6 w-8 h-8 border-b-2 border-r-2 border-gray-800 rounded-br-xl" />
              {loading ? (
                <div className="relative flex justify-center items-center h-12">
                  <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                <p className="relative text-lg font-semibold text-gray-700">
                  {t("Scan the product")} <br /> {t("barcode_checker")}
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        className={`bg-blue-800 text-white text-center py-4 text-sm flex items-center justify-center`}
      >
        <span className="me-1">
          {t("Powered by")}
        </span>
        <img src={logo} className="h-[3vh]" alt="Logo" />
      </div>

      {/* Barcode Scanner */}
      <BarcodeScanner
        onScan={(data) => {
          setBarcode(data);
          searchBarcodeResult(data);
        }}
        onError={(err) => console.error(err)}
      />
    </div>
  );
};

export default PriceChecker;
